import { useEffect, useRef } from 'react'

import { TContent, TGetItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'

import { useAuth } from '@/auth/useAuth'
import { useSession } from '@/core/session/useSession'
import { trackLTPPaymentScreen, trackPageView } from '@/events/events'

function useTrackLTPPageAndPaymentScreen(
  config: IConfig,
  getItem: TGetItemFn,
  pageTitle: string,
  contentData: TContent | undefined,
  pageName: PageName
) {
  const { user } = useAuth()
  const sessionContext = useSession()
  const oneTimeTrack = useRef<boolean>(false)

  useEffect(() => {
    if (oneTimeTrack.current) {
      return
    }
    if (!contentData) {
      return
    }
    trackPageView(
      pageName,
      config.PARTNER_ID,
      config.APP_ID,
      config.PAGE_SET_ID,
      sessionContext,
      user,
      [],
      [],
      undefined,
      undefined,
      undefined,
      contentData.internalPriceId
    )
    trackLTPPaymentScreen(
      pageName,
      config.PARTNER_ID,
      config.APP_ID,
      config.PAGE_SET_ID,
      contentData?.internalPriceId,
      sessionContext,
      user
    )
    document.title = pageTitle
    oneTimeTrack.current = true
  }, [config, getItem, pageTitle, user, contentData, sessionContext, pageName])

  return oneTimeTrack.current
}

export default useTrackLTPPageAndPaymentScreen
